import { useContext } from 'react';

import { featuresContext } from './context.js';

export const useFeatures = () => useContext(featuresContext);
